import { Arrow } from './ui/arrow';
import { Panel } from './ui/panel';
import { Root } from './ui/root';
import { Slide } from './ui/slide';
import { Track } from './ui/track';

export const Carousel = {
  Root,
  Panel,
  Track,
  Slide,
  Arrow,
};
